// The FR dictionary — the house's language and the ONE dictionary that
// travels in the main bundle (audit 10/09 bis, perf n°4): `t()` is called
// synchronously everywhere, before React mounts included, and every other
// language falls back to it. Read only through lib/i18n.js.

const FR = {
    brandTagline: 'Résidence Hôtelière · Autun',
    brandPromise: 'Chaque suite est une porte sur Autun',
    heroEyebrow: 'Le Gardien du Manoir',
    heroTitle: 'Demandez à Médard',
    launchSubtitle: "Le gardien de la mémoire d'Autun",
    appErrorTitle: 'Médard reprend son souffle',
    appErrorBody: 'Une trace s\'est dérobée un instant. Rechargez la page — je reviens aussitôt.',
    appErrorReload: 'Recharger la page',
    heroSubtitle: "Hibou-sentinelle d'Augustodunum, je veille sur l'histoire de la cité. Posez-moi votre question — le Livre s'animera.",
    enterCta: 'Entrer dans le Manoir',
    listenCta: 'Demander à Médard',
    textPlaceholder: 'Posez votre question à Médard…',
    sendBtn: 'Demander',
    idleHint: 'Touchez le micro ou écrivez',
    listening: 'Écoute…', thinking: 'Médard réfléchit…', speaking: 'Médard vous répond',
    bookSilent: 'Le Livre attend votre première question.',
    bookOpens: "Le Livre s'ouvre…",
    sourcesLabel: 'Sources vérifiées',
    keyFactsLabel: 'Faits notables',
    suggestionsLabel: 'Pour aller plus loin',
    // « Médard, montre-moi » — the tappable card under an answer that carries
    // a show_entity (the fiche the guest asked to SEE), one label per type.
    showEntityMonument: 'Voir le monument',
    showEntityTresor: 'Voir dans les Trésors',
    showEntityPersonnage: 'Voir le personnage',
    // LE SORT DE LA PROMESSE — la ligne discrète sous une réponse où Médard
    // a avoué son ignorance et promis un humain (Loi 1). SEUL `Recorded`
    // affirme que la question est arrivée : le serveur ne l'envoie que
    // lorsqu'il a VU l'écriture aboutir. Les deux autres disent l'absence de
    // confirmation — vraies dans le pire cas — et proposent l'autre porte
    // (la conciergerie), quand un numéro est configuré : sans numéro, la
    // ligne honnête reste seule plutôt que de porter un bouton mort.
    //
    // ON NE NOMME QUE CE QUI EXISTE (Loi 1). Ces lignes ont d'abord dit
    // « notre Chef Concierge », en sept langues. Ce titre n'est pas sorti de
    // nulle part — il vient d'une phrase de `memory/LOBBY_INSTALL_SPEC.md`
    // (« the guest they're being connected to the Head Concierge »), reprise
    // dans PLAN.md — mais il n'existe nulle part ailleurs : ni dans /canon,
    // ni dans /lore, ni dans /guardrails, ni dans /docs. Ce n'est donc pas un
    // rôle de la maison, c'est le mot d'un cahier des charges. Deux raisons
    // de ne pas le montrer à un invité : il place un chef AU-DESSUS du
    // concierge, alors que le concierge du Manoir, c'est Médard lui-même
    // (`footerNote`) ; et l'escalade n'atterrit chez aucun concierge, mais
    // chez Vincent Vautrin, Directeur.
    // Le vocabulaire employé ici est donc celui de la maison, déjà établi
    // ailleurs dans ce fichier (`profilConcierge`, `restConciergeCta`) : la
    // CONCIERGERIE — le service, pas une personne. Et on ne nomme personne :
    // une escalade est un geste de la maison, pas une mise en relation
    // nominative. Le libellé du bouton (`escalationReachConcierge`) dit la
    // même chose, exprès : la question part là où le bouton mène.
    escalationRecorded: "Votre question a rejoint le registre de notre conciergerie.",
    escalationPending: "Votre question chemine vers notre conciergerie ; je n'en ai pas encore l'accusé de réception.",
    escalationUnconfirmed: "Je n'ai pas pu obtenir confirmation que votre question soit parvenue à notre équipe.",
    escalationReachConcierge: "Joindre la conciergerie",
    escalationWaMessage: "Bonjour, j'ai posé une question à Médard et j'aimerais la réponse d'une personne du Manoir.",
    monumentsLabel: 'Pierres de Bourgogne',
    monumentsHint: 'Touchez un monument pour interroger Médard à son sujet',
    // « Personnages » — the verified historical figures of Autun.
    catPersonnages: 'Personnages',
    personnagesLabel: "Figures d'Augustodunum",
    personnagesTitle: "Les personnages d'Autun",
    personnagesSubtitle: 'Celles et ceux qui ont marqué la cité — touchez un portrait, Médard vous le présente.',
    creusentTitle: "Ceux qui creusent encore",
    creusentSubtitle: "Moi, je ne fais que raconter. Les vrais gardiens, ce sont ceux qui creusent encore.",
    personnagesEmpty: "Les portraits s'écrivent encore — revenez bientôt.",
    personnagesUnavailable: 'Je n\'arrive pas à charger les portraits pour l\'instant — réessayez dans un moment.',
    personnageDebattu: 'Attribution débattue',
    personnagesLinkedMonument: 'Monument lié',
    personnagesOpenMonument: 'Voir le monument',
    personnagesListen: 'Écouter Médard',
    personnagesCta: 'Découvrir les personnages',
    explorerFiguresTitle: 'Les grandes figures d’Autun',
    explorerFiguresSub: "Celles et ceux qui ont écrit l'histoire de la ville, d'Augustodunum à nos jours.",
    // « Trésors » — the verified treasures of Autun (canon/tresors), the
    // Book's cabinet of wonders. Gallery header = the Explorer rail's keys.
    catTresors: 'Trésors',
    tresorsLabel: 'Le cabinet des merveilles',
    tresorsTitle: "Les trésors d'Autun",
    tresorsSubtitle: "Les merveilles que la ville a livrées ou qu'elle garde encore — et où les admirer.",
    tresorsEmpty: 'Les trésors rejoignent le cabinet — Médard prépare leurs récits.',
    tresorsUnavailable: 'Je n\'arrive pas à charger les trésors pour l\'instant — réessayez dans un moment.',
    tresorsLinkedMonument: "Où l'admirer",
    // Le MÊME bloc, requalifié dès que le cartel « où voir cette pièce » a
    // répondu (revue design du 22/08/2026) : deux blocs également cliquables
    // ne peuvent pas donner deux réponses à « où ». Le monument lié reste
    // une vraie information de musée — le lieu de la découverte, la
    // collection d'origine, le monument que la pièce ornait — il ne mérite
    // simplement pas le verbe « admirer » quand la pièce est ailleurs.
    tresorsLieuLie: 'Le lieu lié',
    tresorsOpenMonument: 'Voir le lieu',
    // « Où voir cette pièce aujourd'hui » — le cartel (chantier 22/08/2026).
    // Un invité finissait le récit d'un chef-d'œuvre du Rolin sans jamais
    // apprendre que le musée est fermé depuis octobre 2022. Le lieu est
    // désormais un FAIT du canon (`ou_voir`), et ces libellés le disent ;
    // le statut, les horaires et le tarif restent lus sur la fiche du lieu.
    tresorOuVoirLabel: "Où voir cette pièce aujourd'hui",
    tresorOuVoirReserveNote: 'Dans les collections du musée — pièce non visible pendant les travaux.',
    // Le cas rare et joyeux : la pièce est SORTIE des réserves. Sans cette
    // note, le badge « Ouvert » du Muséum disait que la porte est ouverte,
    // jamais que la pièce est derrière (revue design 22/08/2026). Le nom de
    // l'exposition est celui que les trois fiches du canon attestent — il
    // expire avec la valeur `ou_voir` qui le porte, jamais avant.
    tresorOuVoirVisibleNote: "Visible en ce moment, dans l'exposition « Merveilles choisies »",
    tresorOuVoirInSitu: 'Toujours en place, sur son monument',
    tresorOuVoirHorsAutun: "Hors d'Autun",
    tresorOuVoirInconnu: 'Lieu de conservation à confirmer',
    // « Si vous y allez » — le cartel de ce qu'on trouve SUR PLACE (canon
    // `sur_place`, chantier 24/08/2026). Steven : « Il y a pas mal de
    // monuments qui existent plus… il faut bien le mentionner, que les gens
    // se pointent pas là-bas et qu'il y a rien. »
    //
    // Six états, un seul axe : la question que l'invité se pose au moment de
    // décider s'il y va. `enfoui` n'est PAS `disparu` — sous vos pieds n'est
    // pas il n'en reste rien, et la traduction doit garder la différence.
    // `surPlaceAucun` est l'aveu : le canon n'a rien d'honnête à proposer à
    // la place, et Médard le dit plutôt que d'envoyer quelqu'un au hasard.
    surPlaceLabel: 'Si vous y allez',
    surPlaceVisitable: 'On visite',
    surPlaceVisitableNote: 'Le lieu est là, et il vous accueille.',
    surPlaceExterieur: "De l'extérieur",
    surPlaceExterieurNote: "L'édifice est debout — mais il ne se découvre que du dehors.",
    surPlaceVestiges: 'Des vestiges',
    surPlaceVestigesNote: "Des restes bien réels, que l'on approche et que l'on touche.",
    surPlaceEnfoui: 'Enfoui',
    surPlaceEnfouiNote: "Rien en surface : c'est sous vos pieds.",
    surPlaceDisparu: 'Disparu',
    surPlaceDisparuNote: "Il n'en reste rien — le lieu porte autre chose aujourd'hui.",
    surPlaceInaccessible: 'Fermé au public',
    surPlaceInaccessibleNote: 'Le lieu existe, mais il ne se visite pas.',
    surPlaceALaPlace: 'À voir à la place',
    surPlaceAucun: 'Rien à voir sur place — je préfère vous le dire que vous y envoyer.',
    // « Fêtes & Spectacles » — la cité vivante (canon/evenements, arbitrage
    // propriétaire du 02/08/2026). Le chapitre du Livre ET le rail Explorer
    // partagent ce bloc : mêmes mots, deux surfaces.
    catFetes: 'Fêtes & Spectacles',
    fetesLabel: 'Fêtes & Spectacles',
    fetesTitle: 'La cité vivante',
    fetesSubtitle: "Les fêtes, les feux et les spectacles qui font revivre Autun — ce qu'ils sont, et qui les porte.",
    fetesEmpty: 'Les fêtes rejoignent le calendrier — Médard prépare leurs récits.',
    fetesUnavailable: "Je n'arrive pas à charger les fêtes pour l'instant — réessayez dans un moment.",
    fetesLinkedMonument: 'Où la vivre',
    // Loi 1 — la nuance de la fiche (canon `confidence`) est TOUJOURS montrée :
    // c'est elle qui porte « toujours confirmer les dates auprès de l'Office
    // de tourisme ». Ce libellé n'est que son chapeau.
    fetesConfidenceLabel: 'La nuance de Médard',
    fetesDatesCaveat: 'Ces dates sont celles de la dernière édition que j\'aie lue. Avant de vous déplacer, un mot à l\'Office de tourisme vous dira celles de cette année.',
    explorerFetesLabel: 'Fêtes & Spectacles',
    explorerFetesSub: 'la cité vivante',
    // LA FRISE DES ÉPOQUES — parcourir Autun par le temps (chantier 22/08/2026).
    // Les neuf couches sont un VOCABULAIRE FERMÉ du canon (bloc `frise:` dans
    // chaque fiche) ; ces libellés en sont la seule forme montrée à l'invité —
    // le jeton canon (« ville-tardive ») ne sort jamais à l'écran.
    // Aucun compte n'est écrit ici : `friseCount*` porte un {n} que l'API
    // remplit depuis le canon.
    friseLabel: 'La frise des époques',
    friseIntro: 'Autun ne se visite pas, elle se feuillette. Choisissez une couche.',
    friseCountOne: '{n} trace',
    friseCountOther: '{n} traces',
    friseCoucheAvantRome: 'Avant Rome — la terre des Éduens',
    friseCoucheAugustodunum: "Augustodunum — la sœur et l'émule de Rome",
    friseCoucheVilleTardive: 'La ville tardive et les premiers chrétiens',
    friseCoucheAbbayes: 'Le temps des abbayes',
    friseCoucheGislebertus: 'Le siècle de Gislebertus',
    friseCoucheRolin: 'Le siècle des Rolin',
    friseCoucheClassique: 'Des Jésuites aux Lumières',
    friseCoucheErudits: 'Le siècle des érudits et des fouilles',
    friseCoucheEncore: 'Ceux qui creusent encore',
    friseCoucheHorsDuTemps: 'Hors du temps',
    friseBornesAvantRome: 'Du Néolithique à 15 av. J.-C.',
    friseBornesAugustodunum: '15 av. J.-C. – IIIᵉ siècle',
    friseBornesVilleTardive: 'IVᵉ – Vᵉ siècle',
    friseBornesAbbayes: 'VIᵉ – Xᵉ siècle',
    friseBornesGislebertus: 'XIᵉ – XIIIᵉ siècle',
    friseBornesRolin: 'XIVᵉ – XVᵉ siècle',
    friseBornesClassique: 'XVIᵉ – XVIIIᵉ siècle',
    friseBornesErudits: 'XIXᵉ siècle',
    friseBornesEncore: "XXᵉ siècle – aujourd'hui",
    friseBornesHorsDuTemps: 'Ce que nos sources ne datent pas',
    friseFamilleMonument: 'Monument',
    friseFamilleTresor: 'Trésor',
    friseFamillePersonnage: 'Figure',
    friseFamilleEvenement: 'Rendez-vous',
    friseDatationDebattue: 'Datation débattue',
    friseAussiDans: 'Aussi dans',
    friseRenvoi: "D'autres pièces de ce siècle",
    friseCoucheEmpty: "Cette époque n'a encore aucune trace à montrer.",
    // « Vide » et « pas su lire » sont deux phrases DIFFÉRENTES (Loi 1, revue
    // du 22/08/2026) : la première affirme quelque chose du canon, la seconde
    // avoue une panne. Formule reprise telle quelle de la famille de la maison
    // (`tresorsUnavailable`, `personnagesUnavailable`, `fetesUnavailable`) —
    // une huitième tournure d'excuse n'apporterait rien. Le bouton reprend
    // `retry`, qui existe déjà dans les sept langues.
    friseUnavailable: "Je n'arrive pas à charger la frise pour l'instant — réessayez dans un moment.",
    // ── LES VOIES PARALLÈLES — la SECONDE lecture de la frise ─────────────
    // La bande lit une époque à la fois ; cet écran-ci les met côte à côte,
    // les quatre familles croisant les dix couches. Rien de neuf n'y est
    // affirmé : les comptes sont ceux que l'API calcule déjà sur le canon
    // (`couches[].familles`), la vue ne fait que les ranger sur un axe.
    friseVoiesTitle: 'Les voies parallèles',
    friseVoiesIntro: "Les familles côte à côte, époque par époque, à la même échelle : une voie se suit de haut en bas, une époque se lit de gauche à droite.",
    friseVoiesEmpty: "La frise n'a encore aucune voie à montrer.",
    // Les DEUX doutes du canon, séparés jusque dans l'agrégat : les fondre en
    // un seul nombre dirait à l'invité qu'on ne sait rien d'une époque, alors
    // qu'on sait précisément quoi (Loi 1). {n} vient des fiches, jamais d'un
    // littéral — et la tournure vaut au singulier comme au pluriel.
    friseVoiesDatation: 'Datation débattue : {n}',
    friseVoiesAttribution: "Attribution débattue : {n}",
    period: 'Époque', category: 'Catégorie', languageLabel: 'Langue', sessionLabel: 'Conversation',
    stopAudio: 'Arrêter la voix',
    share: 'Partager', shareCopied: 'Lien copié',
    // Ni le partage natif ni le presse-papiers : le bouton doit le DIRE.
    shareFailed: 'Impossible de partager depuis ce navigateur',
    offlineVoice: 'La voix premium est indisponible — Médard reste lisible dans le Livre.',
    retry: 'Réessayer', monumentsError: 'Impossible de charger les monuments.',
    offlineBanner: 'Vous êtes hors ligne — Médard vous attend, patient.', backOnline: 'Connexion rétablie.',
    serverBanner: 'Médard ne répond pas pour l\'instant — ce n\'est pas votre connexion. Il revient vite.',
    rateLimited: 'Doucement, voyageur — Médard reprend son souffle. Réessayez dans un instant.',
    micDenied: 'Microphone refusé — utilisez le clavier pour parler à Médard.',
    micBlocked: 'Le micro est bloqué — autorisez-le dans les réglages de votre navigateur (sur iPhone : « aA » dans la barre d’adresse → Réglages du site → Microphone → Autoriser), puis rechargez.',
    micNoDevice: 'Aucun micro détecté — écrivez votre question à Médard.',
    micTranscribeFailed: 'La reconnaissance vocale a échoué — réessayez, ou écrivez votre question à Médard.',
    micNoSpeech: 'Je n\'ai rien saisi — reposez votre question, je vous écoute.',
    micSttDown: 'La reconnaissance vocale est momentanément indisponible — écrivez votre question à Médard.',
    micListening: 'Médard vous écoute — faites une pause et il répondra',
    // Hands-free voice loop (cœur du réacteur). « Audience apaisée » : la
    // conversation continue est le comportement PAR DÉFAUT de la voix — les
    // clés du pilulier (handsFreeOn/Off) sont retirées ×5.
    handsFreeListening: 'Médard vous écoute…',
    handsFreeResume: 'Touchez le micro pour continuer.',
    handsFreeEnded: 'Médard se retire — touchez le micro quand vous souhaitez reprendre.',
    interruptAndSpeak: "L'interrompre et parler",
    audienceInterruptHint: "Touchez pour l'interrompre",
    audienceSpeak: 'Parler à Médard',
    audienceClefInvite: "J'ai une Clef du Manoir",
    // Compact header pill (Audience proscenium, 18/07) — the short form.
    audienceClefShort: "J'ai une Clef",
    // Concierge
    concierge: 'Le Concierge',
    restaurants: 'Tables d\'Autun', tourism: 'Office de Tourisme', taxi: 'Appeler un taxi',
    restaurantsUnavailable: 'Je n\'arrive pas à ouvrir le carnet des tables pour l\'instant — réessayez dans un moment.',
    hoursUnconfirmed: 'Les mises à jour de la conciergerie ne sont pas lisibles à l\'instant — un appel à l\'établissement confirmera l\'ouverture.',
    verificationUnavailable: 'Je n\'ai pas pu croiser ces adresses avec OpenStreetMap à l\'instant — elles viennent de notre carnet, vérifié à la main. Un appel avant de partir reste la sagesse.',
    taxisUnavailable: 'Je n\'arrive pas à lire les numéros de taxi pour l\'instant — réessayez dans un moment.',
    openInMaps: 'Itinéraire dans Plans', callRestaurant: 'Appeler', visitWebsite: 'Site web',
    walkingFromManoir: 'À pied du Manoir',
    mapCta: 'Carte', reserveCta: 'Réserver', phoneUnlisted: 'Tél. non publié',
    whatsappCta: 'WhatsApp le Concierge',
    whatsappPrefill: 'Bonjour, je vous écris depuis l\'application Médard du Manoir d\'Autun…',
    profilConcierge: 'Conciergerie',
    // Booklet
    booklet: 'Livret du Voyageur', bookletDescription: "Téléchargez en PDF tous les sujets explorés avec Médard.",
    bookletDownload: 'Télécharger le Livret', bookletPlaceholderName: 'Votre prénom (optionnel)',
    bookletEmail: 'Recevoir par email', bookletEmailPlaceholder: 'votre@email.fr',
    bookletEmailSending: 'Envoi en cours…', bookletEmailSent: 'Carnet envoyé !',
    bookletEmailError: 'Envoi impossible. Réessayez plus tard.',
    bookletDownloadError: 'Téléchargement impossible. Réessayez dans un moment.',
    // Idle
    legendsMode: 'Légendes du Manoir', legendsHint: 'Médard partage une anecdote toutes les minutes',
    tap_to_wake: 'Touchez pour interroger Médard',
    // Sync
    lobbyMirror: 'Vous suivez le lobby en temps réel',
    // Visitor name
    nameLabel: 'Votre prénom',
    namePlaceholder: 'Ex. Marie',
    nameOptional: '(facultatif — Médard pourra vous saluer)',
    nameSkip: 'Continuer sans prénom',
    accuracyBadge: 'Précision absolue',
    accuracyBadgeHint: 'Toutes les réponses de Médard sont vérifiées pour garantir l\'exactitude historique et la citation des sources.',
    // Voice
    micStart: 'Démarrer l\'enregistrement', micStop: 'Arrêter l\'enregistrement',
    // Photography placeholder
    photoComing: 'Photographie à venir',
    // Restaurant detail sheet — labels (the canon values stay in French)
    restCategory: 'Catégorie', restAddress: 'Adresse', restHours: 'Horaires',
    restAccessFromManor: 'Accès depuis le Manoir', restMinWalk: 'min à pied', restMinDrive: 'min en voiture',
    restParking: 'Stationnement', restParkingValue: 'Parking gratuit · Place du Champ-de-Mars',
    restPrice: 'Gamme de prix', restPhone: 'Téléphone', restReviews: 'avis',
    restMenuEyebrow: 'La Carte', restMenuTitle: 'Spécialités appréciées',
    restMenuFull: 'Carte complète sur le site officiel', restVisitorsVoice: 'Voix de nos visiteurs',
    restDirectorNote: 'Note du Directeur', restConciergeCta: 'Votre concierge vous accompagne',
    ratingOutOf5: 'sur 5',
    restCategories: {
        gastronomique: 'Gastronomique', bistronomique: 'Bistronomique',
        brasserie: 'Brasserie / Traditionnel', italien: 'Italien / Pizzeria',
        creperie: 'Crêperie', poissons: 'Poissons & fruits de mer', cafe: 'Café / Salon de thé',
    },
    // Vincent's picks
    vincentPicksEyebrow: 'Conciergerie · Sélection du Directeur',
    vincentPicksTitle: 'Les Pépites de Vincent',
    vincentPicksSubtitle: 'Trois tables choisies personnellement par notre directeur, selon votre humeur du soir.',
    moodRomantic: 'Romantique', moodFamily: 'Familial', moodGem: 'Pépite locale',
    selectionComing: 'Sélection à venir', vincentChoice: 'Choix de Vincent',
    reviewsLabel: 'avis', minOnFoot: 'min à pied', minByCar: 'min en voiture',
    discover: 'Découvrir',
    // Vincent relay modal
    vincentAsk: 'Demander à Vincent', vincentSendCompact: 'Envoyer à Vincent',
    vincentPrivateConcierge: 'Conciergerie privée',
    vincentIntro: 'Vincent Vautrin, notre directeur, recevra votre demande et s\'en occupera personnellement.',
    vincentYourName: 'Votre nom',
    vincentPhoneLabel: 'Téléphone — pour qu\'il vous rappelle (optionnel)',
    vincentRequestLabel: 'Votre demande',
    vincentNamePh: 'Mme Dupont',
    vincentRequestPh: 'Réservation, demande spéciale, urgence...',
    vincentSent: 'Demande transmise à Vincent',
    vincentSendError: 'Votre demande n’est pas partie. Réessayez, ou demandez à la réception.',
    cancel: 'Annuler', send: 'Envoyer', sending: 'Envoi…', close: 'Fermer',
    loading: 'Chargement…',
    // Signature itineraries CTA
    // Footer
    footerNote: 'Médard · Concierge du Manoir d\'Autun',
    // Book Spread — navigation page (Clefs-d'Or directory)
    bookNavEyebrow: 'Conciergerie du Manoir',
    bookNavTitle: 'Sommaire',
    // Le nom que le lecteur d'écran annonce pour la barre du bas. « Sommaire »
    // désignait le sommaire du Book desktop — sur téléphone c'est la navigation.
    navMainLabel: 'Navigation principale',
    bookNavOpen: 'Ouvrir le sommaire',
    bookNavClose: 'Fermer le sommaire',
    catAnswer: 'Médard répond',
    catWeekend: 'Ce week-end à Autun',
    catRestaurants: 'Restaurants',
    catMonuments: 'Monuments & visites',
    catBalade: 'La Balade de Médard',
    baladeTitle: 'Au fil des pierres',
    baladeIntro: "Suivez Médard à travers les pierres essentielles d'Autun — une promenade à pied, d'un chef-d'œuvre à l'autre.",
    baladeTotal: 'La promenade',
    baladeWalkTo: "à pied jusqu'à l'étape suivante",
    baladeStops: 'étapes',
    baladeMinutes: 'min',
    baladeOpenStop: 'Écouter Médard',
    baladeMapFallback: "Carte momentanément indisponible — voici l'itinéraire.",
    baladeModeIcones: "Les icônes d'Autun",
    baladeModeCompose: 'Composez votre balade',
    baladeModeSignature: 'Parcours signature',
    baladeDoorShelfTitle: 'Les balades de Médard',
    baladeDoorShelfSub: 'Les parcours composés par la maison — cartographiés, racontés, prêts à suivre.',
    baladeDoorComposeTitle: 'Composer ma balade',
    baladeDoorComposeSub: "Dites-moi vos envies — j'ordonne le chemin et je vous raconte chaque pierre.",
    baladeBack: 'Retour',
    baladeThemeFilterLabel: 'Filtrer par thème',
    baladeThemeFilterAll: 'Toutes',
    baladeThemeFilterRomain: 'Romaine',
    baladeThemeFilterArtRoman: 'Art roman & sacré',
    baladeThemeFilterNature: 'Nature & aurore',
    baladeThemeFilterVignes: 'Châteaux & vignes',
    baladeThemeFilterEmpty: "Aucune balade de ce thème pour l'instant.",
    baladeIconesTag: "Parcours d'ouverture",
    baladeIconesTheme: "Les pierres essentielles d'Autun, d'un chef-d'œuvre à l'autre.",
    baladeSigIntro: "De l'aurore au crépuscule, de l'archéologie aux vignes — les parcours composés par Médard, cartographiés et pensés pour votre humeur.",
    baladeSigStops: 'Étapes du parcours',
    baladeSigOnSite: '{n} min sur place',
    baladeSigWalkNext: 'puis {n} min à pied',
    baladeSigDriveNext: 'puis {n} min en voiture',
    baladeSigRR: 'Range Rover du Manoir',
    baladeSigRRok: 'Disponible — Vincent au volant.',
    baladeSigRRno: "Indisponible aujourd'hui — ce parcours nécessite le Range Rover du Manoir. Demandez à Vincent de l'activer ou choisissez un autre parcours.",
    baladeSigPicnic: 'Le panier de Vincent',
    baladeSigLoop: 'Itinéraire conseillé · Boucle depuis le Manoir',
    baladeSigEmpty: 'Les parcours signature sont momentanément indisponibles.',
    baladeComposeIntro: "Dites-moi ce qui vous attire et le temps dont vous disposez — je composerai votre promenade parmi les pierres d'Autun.",
    baladeThemeRomain: 'Autun la Romaine',
    baladeThemeSacre: 'Pierres sacrées',
    baladeThemeArts: 'Arts & musées',
    baladeThemeCoeur: 'Cœur de ville',
    baladeTime1h: 'Une heure',
    baladeTime2h: 'Deux heures',
    baladeTimeDemi: 'Une demi-journée',
    planTitle: 'Le Planificateur de Médard',
    planIntro: 'Décrivez la journée dont vous rêvez à Autun — je la compose.',
    planPlaceholder: "Ex. : une matinée autour de l'histoire romaine, puis flâner au cœur de la ville…",
    planCompose: 'Médard compose',
    planLeadMatched: 'Voici votre journée « {theme} », composée pour vous.',
    planLeadDiscover: "Pour commencer, voici une belle découverte d'Autun.",
    planNoStops: "Je n'ai pas encore de pierre pour cette envie précise — essayez une autre inspiration, ou demandez à votre conciergerie.",
    planPrint: "Garder ma journée (PDF)",
    planPrintTitle: "Ma journée à Autun",
    planPrintBlocked: "Votre navigateur a refusé la fenêtre d'impression — autorisez-la, puis réessayez.",
    planBeyond: 'Pour la table, les vins ou le spa de votre journée, votre conciergerie compose avec vous — moi, je ne raconte que les pierres.',
    decouvrirTitle: 'Les Merveilles de Médard',
    // COUNTED, never a category (Loi n°1). « Les apparitions … » announced an
    // open collection over what is, to this day, a very short list. The number
    // is filled at render from the rows actually shown; « à ce jour » dates it.
    decouvrirIntroOne: "À ce jour, j'ai préparé une apparition en réalité augmentée pour votre séjour. Ouvrez-la, puis laissez la magie opérer.",
    decouvrirIntroOther: "À ce jour, j'ai préparé {n} apparitions en réalité augmentée pour votre séjour. Ouvrez-en une, puis laissez la magie opérer.",
    decouvrirArEyebrow: 'En réalité augmentée',
    decouvrirArHint: "Vivre l'expérience",
    decouvrirOnSite: 'À vivre sur place, votre téléphone à la main.',
    devSimStay: 'Simuler un séjour (aperçu test)',
    devSimStayCta: 'Ouvrir ma Clef (test)',
    servicesTitle: 'Services de la Clef',
    servicesIntro: 'Le confort de votre séjour, d’un geste — votre équipe s’en occupe.',
    servicesGuardrail: 'Chaque demande rejoint votre équipe, qui la confirme avec vous. Rien n’est réservé ni débité depuis l’application.',
    servicesNoteLabel: 'Un mot pour votre équipe',
    servicesNotePlaceholder: 'Ex. : vers 8h, un café et des viennoiseries…',
    servicesSend: 'Envoyer à votre équipe',
    servicesSent: 'C’est transmis. Votre équipe revient vers vous pour confirmer — rien n’est encore réservé.',
    servicesError: 'La demande n’est pas partie — réessayez, ou passez par WhatsApp.',
    servicesFallbackHint: 'L’envoi automatique n’a pas abouti — joignez votre équipe directement, votre demande est déjà écrite :',
    servicesFallbackWa: 'Envoyer par WhatsApp',
    svcBreakfast: 'Petit-déjeuner en chambre',
    svcHousekeeping: 'Ménage & linge',
    svcLateCheckout: 'Départ tardif',
    svcTable: 'Réserver une table',
    clefTeaserEyebrow: 'Derrière la Clef',
    clefTeaserTitle: 'Ce qui s’ouvre avec votre clef',
    clefTeaserHint: 'Saisissez votre code de séjour, ci-dessus, pour ouvrir ces portes.',
    // « Conciergerie ouverte » — the at-a-glance gold seal shown wherever the
    // guest talks to Médard while the Clef is active (owner addition 18/07).
    badgeConciergerieOpen: 'Conciergerie ouverte',
    badgeConciergeriePreview: 'Conciergerie — aperçu',
    // « Pastille invitée » — the guest's short name always visible on the
    // top bar while a Clef (stay) is active (owner request 18/07 night).
    guestPillAria: 'Votre séjour au Manoir — ouvrir Ma Clef',
    guestPillLogin: 'Clef',
    guestPillPreview: 'aperçu',
    baladeComposeCta: 'Composer',
    baladeListen: 'Écouter Médard',
    baladeTruncated: "J'ai gardé les plus belles traces pour le temps que vous avez.",
    baladeSpokenIntro: 'Voici votre promenade « {theme} » : {n} étapes, environ {min} minutes à pied.',
    baladeComposeEmpty: "Pas encore de balade pour ce thème — laissez-moi vous montrer les Trésors d'Autun.",
    baladeStart: 'Démarrer le parcours',
    baladeGuidePrev: 'Précédent',
    baladeGuideNext: 'Suivant',
    baladeGuideEnd: 'Terminer',
    baladeGuideToNext: "vers l'étape suivante",
    baladeGuideArrived: 'Vous y êtes',
    baladeGuideDone: 'Belle promenade — Autun vous a livré ses trésors.',
    baladeGuideGpsHint: 'Activez la localisation pour que Médard vous suive en chemin.',
    baladeGuideKept: "Pour cette balade, chaque fiche d'étape est gardée sur cet appareil : sans réseau, elle s'ouvrira avec son récit, ses faits notables et ses sources, même si l'application doit se rouvrir. Les photographies et la voix de Médard, elles, ne sont pas gardées.",
    baladeGuideKeptSession: "Pour cette balade, chaque fiche d'étape est gardée sur cet appareil : sans réseau, elle s'ouvrira avec son récit, ses faits notables et ses sources, tant que cette page reste ouverte. Les photographies et la voix de Médard, elles, ne sont pas gardées.",
    baladeOfflineNotice: 'Hors réseau, la voix de Médard se tait, les photographies peuvent manquer, et la carte ne montre au mieux que les rues déjà affichées sur cet appareil.',
    baladeGuideVoiceOffline: "Sans réseau, Médard ne peut pas vous dire cette étape : sa voix ne se garde pas sur l'appareil. Son récit vous attend dans la fiche.",
    baladeGuideVoiceNotRecorded: "La voix de Médard n'est pas encore enregistrée pour cette étape. Son récit vous attend dans la fiche.",
    baladeGuideVoiceFailed: "Médard n'a pas pu vous dire cette étape. Son récit vous attend dans la fiche.",
    baladeGuideVoiceOfflineBook: "Sans réseau, Médard ne peut pas vous dire cette étape : sa voix ne se garde pas sur l'appareil.",
    baladeGuideVoiceNotRecordedBook: "La voix de Médard n'est pas encore enregistrée pour cette étape.",
    baladeGuideVoiceFailedBook: "Médard n'a pas pu vous dire cette étape.",
    baladeGuideReadFiche: 'Lire la fiche',
    baladeTilesMissing: "Le fond de carte manque ici : les étapes et le tracé s'affichent sans lui.",
    catRequests: 'Demandes à la conciergerie',
    catManoir: 'Le Manoir & les suites',
    catPassport: 'Passeport du Voyageur',
    // Mobile native shell — bottom tab bar + Explorer (phones, < 768px only)
    tabMedard: 'Médard',
    tabScan: 'Scanner',
    tabExplorer: 'Explorer',
    tabBalades: 'Balades',
    tabManoir: 'Le Manoir',
    // Mobile « Le Manoir » tab — the hotel vitrine + unified concierge + settings
    manoirViewTitle: "Le Manoir d'Autun",
    manoirVersion: 'Version',
    mappingKicker: "Une proposition culturelle — du Manoir à la Ville d'Autun",
    mappingTitle: 'Faire rêver les pierres',
    mappingIntro: "Et si Le Manoir d'Autun et la Ville d'Autun imaginaient ensemble une saison culturelle à ciel ouvert ? Ceci n'est pas encore un programme, mais une proposition : co-créer des rendez-vous où l'histoire d'Augustodunum se raconterait autrement, main dans la main avec celles et ceux qui la protègent.",
    mappingBadge: 'Projet — une proposition du Manoir',
    mappingEventTitle: 'Le Mapping des monuments',
    mappingEventBlurb: "Imaginons la Porte Saint-André — près de deux mille ans de calcaire — réveillée à la nuit tombée par la lumière : des lignes blanc-bleu qui redessineraient ses quatre arcades et conteraient Augustodunum à son apogée, le temps d'une soirée. Le film ci-dessus est notre évocation de cette vision, à explorer avec la Ville d'Autun et le SAVA, dans le plus grand respect de la pierre.",
    mappingCredits: "Un projet imaginé par Le Manoir d'Autun, à proposer à la Ville d'Autun et à son Service archéologique (SAVA) — d'après les recherches du SAVA, de l'Inrap et de la DRAC, et le discours d'Eumène (298 apr. J.-C.).",
    profilSettings: 'Réglages',
    profilLanguage: 'Langue',
    profilGeo: 'Géolocalisation',
    profilGeoCheck: 'Vérifier ma position',
    profilGeoUnavailable: 'Géolocalisation indisponible sur cet appareil.',
    profilGeoDenied: 'Localisation refusée — activez-la dans les réglages de votre navigateur.',
    profilClearCache: 'Vider le cache',
    profilClearCacheHint: 'Efface les données mises en cache par l\'application sur cet appareil, puis recharge.',
    profilClearCacheDone: 'Cache vidé — rechargement…',
    profilBack: 'Retour',
    // « Installer Médard » — add-to-home-screen (Réglages)
    installRow: 'Installer Médard',
    installRowHint: 'L\'application sur votre écran d\'accueil',
    installSheetIntro: 'Deux gestes suffisent pour garder Médard à portée de main :',
    installStep1: 'Touchez Partager dans la barre du navigateur',
    installStep2: 'Choisissez « Sur l\'écran d\'accueil »',
    // « Menu » — le menu mobile organisé (V4.5 W-menu). La devise vit dans
    // /lore (medard-sentinelle.md) — forme canonique, jamais réécrite ici.
    menuTitle: 'Menu',
    menuOpen: 'Ouvrir le menu',
    menuAbout: 'À propos',
    menuMotto: 'Le monde est plus magique qu\'on ne le croit — parce qu\'il est vrai.',
    // The menu-hub (owner #2/#3/#4): the all-access Clef block, the guest's
    // journey (passport) and the best-feature shortcuts.
    menuClefTitle: 'La Clef du Manoir',
    menuClefHint: 'Votre passe pour tout le Manoir',
    menuJourney: 'Mon parcours',
    menuFeatures: 'À découvrir',
    menuLanguageChange: 'Changer de langue',
    explorerTitle: "La mémoire d'Autun",
    explorerIntro: "Monuments, trésors et grandes figures — touchez, et Médard vous en conte l'histoire.",
    explorerMonumentsLabel: 'Les monuments d’Autun',
    explorerMonumentsSub: "Chaque pierre a son histoire — touchez une carte pour l'entendre.",
    explorerNatureLabel: 'Nature & découverte',
    explorerNatureSub: "L'eau, la forêt et les panoramas — la mémoire d'Autun se visite aussi à ciel ouvert.",
    explorerMapLabel: 'Sur la carte',
    explorerMapSub: "Touchez une pierre sur la carte — Médard vous en conte l'histoire.",
    explorerTresorsLabel: 'Le cabinet des merveilles',
    explorerTresorsTitle: "Les trésors d'Autun",
    explorerTresorsSub: "Les merveilles que la ville a livrées ou qu'elle garde encore — et où les admirer.",
    // Les sections du cabinet (Steven, 20/08/2026 : « il faut être plus
    // organisé au lieu d'avoir tout en bloc qui descend »). Des CLEFS de
    // catégorie — le vocabulaire fermé du canon (TRESOR_CATEGORIES) traduit
    // ici, jamais servi tel quel à l'invité.
    tresorsCatSculpture: 'Sculpture',
    tresorsCatPeinture: 'Peinture',
    tresorsCatArcheologie: 'Archéologie',
    tresorsCatOrfevrerie: 'Orfèvrerie & verre',
    // « Musées & lieux de visite » (tâche #65) — la section des portes que
    // l'on peut pousser ; un lieu fermé l'affiche sans détour (Loi 1).
    explorerLieuxLabel: 'Musées & lieux de visite',
    explorerLieuxSub: "Où la mémoire d'Autun se visite — et l'état de chaque porte, dit sans détour.",
    lieuStatusOpen: 'Ouvert',
    lieuStatusSeasonal: 'En saison',
    lieuStatusClosed: 'Fermé',
    lieuHoursLabel: 'Horaires',
    lieuPriceLabel: 'Tarif',
    explorerListToggle: 'Voir la liste',
    explorerMapToggle: 'Voir la carte',
    explorerManoirLabel: "Le Manoir d'Autun",
    explorerManoirHint: 'Votre point de départ',
    // Mobile home feed — editorial edition (APP_IA_AUDIT §5 W2)
    homeAskInvite: "Demandez-moi Autun — je n'en conte que le vrai.",
    homeGuardianEyebrow: 'Gardien du Manoir',
    audienceEyebrow: "L'Audience privée",
    audienceClose: 'Retour',
    // « Le Professeur ajuste son monocle » — Mode Expert v1. The MenuSheet
    // persona control (Langue-control grammar), the Audience transformation
    // ritual, and the UI-OWNED honesty note (deterministic, never model-
    // generated — Loi 1). Translation rule locked in review: the ×4 versions
    // carry STRICTLY the same claims as the FR — no version may say more.
    menuProfesseurRow: 'Mode expert',
    menuProfesseurConteur: 'Médard, conteur',
    menuProfesseurSavant: 'Le Professeur',
    menuProfesseurChange: 'Changer le mode de Médard',
    menuProfesseurHint: 'Réponses savantes, sourcées aux publications ouvertes — débats inclus.',
    menuProfesseurLocked: 'Réservé aux détenteurs de la Clef du Manoir',
    menuProfesseurNote: "Le Professeur vous parle depuis notre bibliothèque vérifiée, bâtie sur les publications ouvertes — Gallia, Persée, l'Inrap, la Base Mérimée, les bilans du Service archéologique d'Autun, la Société éduenne. Il nomme les chercheurs, et quand la recherche ne sait pas encore, il vous le dira — c'est sa fierté. Deux limites, dites franchement : nos fiches attendent encore la relecture des archéologues de la ville, et il ne consulte aucune base de données en direct. Pour vos propres documents, l'atelier n'est pas encore ouvert — confiez-les à l'équipe humaine, qui les recevra avec joie.",
    audienceProfesseurEyebrow: "L'Audience du Professeur",
    audienceProfesseurSeal: 'Mode Professeur actif — ouvrir les réglages',
    audienceTransformationLabel: 'Médard ajuste son monocle…',
    expertOpenQuestionsLabel: 'Questions ouvertes',
    // The server's état enum on each open question, localized (exact-enum
    // lookup in AnswerView; an unknown value ships raw — Loi 1).
    expertEtatDebattu: 'attesté mais débattu',
    expertEtatHypothese: 'hypothèse',
    expertEtatInconnu: 'inconnu',
    // « Hybride progressif » (cœur-du-réacteur A) — the transcript drawer,
    // the question echo line, the folded fact register and the thumbnail
    // lightbox of the redesigned answer display.
    drawerOpen: 'Lire le chapitre',
    drawerClose: 'Replier le chapitre',
    youSaidLabel: 'Vous avez demandé',
    detailsLabel: 'Détails',
    imageExpand: "Agrandir l'image",
    imageClose: "Fermer l'image",
    homeWakeMedard: 'Réveiller Médard',
    eveilSentinelle: 'Sentinelle de porcelaine, mémoire de la cité.',
    eveilTagline: 'Le Gardien veille',
    // « Médard vous accueille » — the first-launch intro film (9 narration
    // beats spoken by Médard + the film chrome). MedardAccueil.jsx.
    accueilTitle: 'Médard vous accueille',
    accueilStart: 'Réveiller Médard',
    accueilSkip: 'Passer',
    accueilEnter: 'Suivez-moi',
    accueilReplay: 'Médard, comment ça marche ?',
    accueilMute: 'Couper le son',
    accueilUnmute: 'Activer le son',
    accueilBeat1: 'Bonjour… et bienvenue au Manoir d\'Autun.',
    accueilBeat2: 'Je suis Médard, le gardien de la mémoire de cette ville.',
    accueilBeat3: 'Posez-moi une question sur Autun — je ne vous conte que le vrai. Si je ne sais pas encore, je vous le dis.',
    accueilBeat4: 'Vous voyez un monument ? Ouvrez l\'Œil de Médard : dirigez votre téléphone vers lui, et je vous révèle son histoire.',
    accueilBeat5: 'Envie de marcher ? Suivez la Balade de Médard — je vous guide de trésor en trésor.',
    accueilBeat6: 'Votre séjour vous attend derrière la Clef du Manoir.',
    accueilBeat7: 'Chaque lieu visité s\'inscrit dans votre passeport de voyageur.',
    accueilBeat8: 'Le monde est plus magique qu\'on ne le croit… parce qu\'il est vrai.',
    accueilBeat9: 'Suivez-moi.',
    galleryLabel: 'Galerie',
    sourceVerified: 'Source vérifiée',
    wikipediaLabel: 'Wikipédia',
    // Sous une image dont la source ne nomme NI auteur NI licence. On montre
    // la photographie — elle vaut mieux qu'un trou — et l'on se tait sur ce
    // qu'on ne sait pas, plutôt que de lui inventer une signature (Loi 2).
    imageCreditUnknown: 'Source à établir',
    homeCardOfDay: "À l'affiche à Autun",
    homeDayTreasureCta: 'Médard raconte',
    homeDayTourCta: 'Voir le parcours',
    homeDayEventCta: "Voir l'agenda",
    homeTreasuresTitle: "Les merveilles d'Autun",
    homeTreasuresAll: 'Tout voir',
    homeStayOpen: 'Découvrir le Manoir',
    // Le même bouton, pour quelqu'un dont la Clef est déjà active sur cet
    // appareil : il ne découvre plus l'hôtel, il y séjourne.
    homeClefOpen: 'Voir ma Clef',
    // Le sceau posé sur une carte de catalogue dont la fiche porte un FILM.
    // Six fiches sur 291 en ont un ; sans ce mot, elles sont introuvables
    // derrière cent cartes (Steven, 13/09).
    siteFilmMark: 'Film',
    // La bande panoramique de l'accueil — purement descriptive de ce qui est
    // dans le cadre (Loi 1 : on nomme ce qu'on montre).
    siteVilleEyebrow: 'La ville',
    siteVilleLine: 'Autun, et la flèche de Saint-Lazare au-dessus des toits.',
    stayTitle: 'Séjourner au Manoir',
    stayLine: 'Huit suites thématiques, huit chapitres d\'Augustodunum — et Médard qui veille.',
    stayCta: 'Réserver',
    staySoon: 'Bientôt — les réservations s\'ouvriront ici.',
    // « Ma Clef du Manoir » — stay-code claim + guest card (W5, §1.3)
    stayClaimPrompt: 'Vous séjournez chez nous ?',
    stayClaimIntro: 'Votre code de séjour vous attend dans votre email de pré-arrivée — ou à la réception.',
    stayClaimCodeLabel: 'Code de séjour',
    stayClaimCodeHint: '6 caractères. Jamais de 0, O, 1, I ni L.',
    stayClaimSurnameLabel: 'Nom de famille (facultatif)',
    stayClaimSubmit: 'Ouvrir ma Clef',
    stayClaimChecking: 'Vérification…',
    stayClaimWrong: 'Ce code ne m\'ouvre rien — vérifiez-le, ou demandez à la réception.',
    stayClaimRetry: 'Le Manoir ne répond pas pour l\'instant — réessayez dans un moment.',
    // 503 — « je ne peux pas vérifier » n'est PAS « votre code est faux ».
    // Deux phrases différentes, une seule est vraie pendant une panne.
    stayClaimUnavailable: 'Nous ne pouvons pas vérifier votre code pour l\'instant — réessayez dans un moment.',
    myClefTitle: 'Ma Clef du Manoir',
    myClefGreeting: 'Bienvenue au Manoir, {name}.',
    myClefSuite: 'Votre suite',
    myClefCheckout: 'Départ',
    myClefKeySoon: 'Bientôt : votre clef digitale.',
    myClefEnd: 'Terminer le séjour',
    // « La porte du Cabinet » — le cercle 2 (chercheurs). Registre sobre et
    // savant : une salle de lecture, pas une chambre. Le code s'entre dans
    // le MÊME champ que la Clef ; l'admission n'ouvre que Le Professeur.
    cabinetTitle: 'Le Cabinet d\'étude',
    cabinetRecognised: 'Le Cabinet vous reconnaît, {name}.',
    cabinetProfesseurOpen: 'Le Professeur vous est ouvert.',
    cabinetInstitutionLabel: 'Rattachement',
    cabinetUntilLabel: 'Admission valable jusqu\'au',
    cabinetScope: 'Cette admission ouvre le registre savant ; elle n\'ouvre aucune porte du Manoir.',
    cabinetDossiersTitle: "Les dossiers d'énigmes",
    cabinetDossiersIntro: "Les questions ouvertes du territoire — chaque fait balisé, chaque hypothèse signée et cotée.",
    cabinetDossiersLoading: 'Ouverture des dossiers…',
    cabinetDossiersError: 'Les dossiers ne répondent pas pour l\'instant — réessayez dans un moment.',
    cabinetDossiersDenied: 'Votre admission n\'ouvre plus les dossiers — écrivez-nous et nous verrons.',
    cabinetDossierQuestion: 'La question',
    cabinetDossierEtat: "L'état de l'art",
    cabinetDossierInconnues: 'Les inconnues',
    cabinetDossierHypotheses: 'Les hypothèses',
    cabinetDossierProtocole: 'Le protocole de preuve',
    cabinetDossierJournal: 'Le journal',
    cabinetDossierSources: 'Les sources',
    cabinetDossierCredits: 'Qui creuse',
    cabinetDossierLangNote: 'Dossier de travail rédigé en français — la langue du corpus.',
    cabinetEnd: 'Quitter le Cabinet',
    // V3 — la scène bronze + le rituel de la Clef (maquettes fondatrices).
    // « La Clef du Manoir » est un nom de marque : jamais traduit (owner).
    clefSceneTitle: 'La Clef du Manoir',
    clefHoldHint: 'Maintenez la clef pour la tourner.',
    clefTurned: 'La Clef tourne — le Manoir vous ouvre ses portes.',
    clefContinue: 'Continuer',
    // Météo réelle d'Autun (Open-Meteo) — clefs de libellés WMO servies par
    // le backend ; rien ne s'affiche quand l'API n'a rien donné (Loi 1).
    weatherClear: 'Ciel dégagé',
    weatherCloudy: 'Nuageux',
    weatherRain: 'Pluie',
    weatherSnow: 'Neige',
    weatherFog: 'Brouillard',
    weatherStorm: 'Orage',
    // Book Spread — content views
    weekendSubtitle: 'L\'agenda officiel de l\'Office de Tourisme du Grand Autunois Morvan.',
    weekendEmpty: "L'agenda de la cité arrive bientôt. Demandez-moi en attendant !",
    weekendUnavailable: 'Je n\'arrive pas à lire l\'agenda de la cité pour l\'instant — réessayez dans un moment.',
    weekendSource: 'Agenda complet',
    eventSource: 'Source',
    eventDetails: 'Détails',
    manoirSubtitle: 'Huit suites thématiques — huit chapitres d\'Augustodunum.',
    suiteAskCta: 'Demander à Médard',
    suiteAskTemplate: 'Médard, parlez-moi de la suite « {name} ».',
    suiteFilmBadge: 'Film Médard',
    suiteFilmSectionEyebrow: 'Le film de la suite',
    suiteFilmPlay: 'Voir le film',
    suiteFilmFullscreen: 'Plein écran',
    suitesEmpty: 'Les suites se dévoileront ici très bientôt — Médard veille sur le Manoir en attendant.',
    suitesUnavailable: 'Je n\'arrive pas à charger les suites pour l\'instant — réessayez dans un moment.',
    passportSubtitle: 'Chaque monument exploré avec Médard appose son tampon.',
    passportEmpty: 'Aucun tampon pour l\'instant — interrogez Médard sur un monument pour ouvrir la collection.',
    passportUnavailable: 'Je n\'arrive pas à ouvrir votre passeport pour l\'instant — réessayez dans un moment.',
    passportStampsLabel: 'Tampons du voyage',
    // « Trésors » — la quête de collection : les œuvres reconnues par l'Œil.
    passportTresorsLabel: 'Trésors du voyage',
    passportTresorsEmpty: 'Aucun trésor pour l\'instant — tendez l\'Œil de Médard vers une œuvre pour l\'ajouter à votre collection.',
    // « Les visites » — les mêmes tampons regroupés par lieu et par JOUR
    // LOCAL, pour que le passeport se lise comme un séjour et non comme un
    // inventaire. Les deux libellés « non consigné » sont la Loi 1 appliquée
    // aux trous : on dit qu'on ne sait pas, on n'invente ni lieu ni date.
    passportVisitsLabel: 'Les visites',
    passportVisitMonumentOne: '{n} monument',
    passportVisitMonumentOther: '{n} monuments',
    passportVisitTresorOne: '{n} trésor',
    passportVisitTresorOther: '{n} trésors',
    passportVisitNoPlace: 'Lieu non consigné',
    passportVisitNoDate: 'Date non consignée',
    // « L'Œil apprend la pellicule » — une visite datée par la photo le dit.
    passportVisitPhotoDay: 'd\'après la photo',
    // « La carte de mon voyage » — les monuments tamponnés, épinglés.
    passportMapLabel: 'La carte de mon voyage',
    passportMapSeenHere: 'Vu ici',
    passportMapFallback: 'Carte momentanément indisponible — vos visites restent ci-dessus.',
    // « L'Œil de Médard » — scanner un monument
    catScan: 'L\'Œil de Médard',
    scanEyeButton: 'Ouvrir l\'Œil de Médard',
    scanSpotlightTitle: 'L\'Œil de Médard s\'ouvre',
    scanSpotlightBody: 'Médard sait désormais reconnaître les monuments. Montrez-lui une façade, il vous racontera son histoire vraie.',
    scanSpotlightCta: 'Essayer l\'Œil',
    scanSpotlightLater: 'Plus tard',
    scanTitle: 'L\'Œil de Médard',
    scanIntro: 'Tendez l\'œil de Médard vers un monument : il le reconnaîtra et vous en contera l\'histoire vraie.',
    scanStart: 'Ouvrir l\'œil',
    scanCapture: 'Photographier',
    scanClose: 'Fermer l\'appareil',
    scanAnalyzing: 'Médard scrute la pierre…',
    scanStamped: 'Tampon ajouté à votre passeport',
    scanTresorStamped: 'Trésor ajouté à votre passeport',
    scanOpenPage: 'Ouvrir la page du Livre',
    scanRetry: 'Nouveau regard',
    scanListen: 'Médard vous raconte…',
    scanNoMatchTitle: 'Une trace encore à lire',
    scanNearbyLabel: 'Monuments tout proches',
    scanWorldEyebrow: 'Au-delà de mes archives',
    scanWorldSourcePrefix: 'D\'après',
    scanWorldReadMore: 'Lire la source',
    // « Médard lit le cartel » — l'étiquette murale du musée, photographiée.
    // C'est la parole du conservateur : une source de rang 1, créditée à part
    // de l'encyclopédie. « Attribué à » restitue le doute DU MUSÉE (Loi 1).
    scanCartelAttributed: 'Attribué à',
    scanCartelDate: 'Datation',
    scanCartelMedium: 'Technique',
    scanCartelCredit: 'd\'après le cartel du musée',
    scanCartelCreditNamed: 'd\'après le cartel du musée — {institution}',
    // La fiche du monde (ETUDE_ARTSCAN §4.2) — les LIBELLÉS des champs
    // structurés ; les valeurs viennent de la source, jamais d'ici. La ligne
    // de provenance sous chaque champ dit qui parle : le cartel (rang 1) ou
    // la lecture de l'Œil lui-même.
    scanWorldFieldArtist: 'Artiste',
    scanWorldFieldBuilder: 'Bâtisseur',
    scanWorldFieldPeriod: 'Période',
    scanWorldFieldLocation: 'Lieu de conservation',
    scanWorldFieldSite: 'Lieu',
    scanWorldFieldFromCartel: 'd\'après le cartel',
    scanWorldFieldFromVision: 'lecture de l\'œuvre',
    // « Une photo d'hier ? Montrez-la-moi » (ETUDE_ARTSCAN §3.4) — la porte
    // assumée vers la pellicule, dans la voix de Médard : un constat, puis
    // l'infinitif. La caméra reste la porte principale.
    scanGalleryLead: 'Une photographie d\'hier ? Montrez-la-moi — je lis aussi les souvenirs.',
    scanGalleryOpen: 'Ouvrir la pellicule',
    scanGalleryLimit: 'Jusqu\'à {n} photographies à la fois.',
    scanBatchProgress: 'Photographie {n} sur {total}',
    scanBatchNext: 'Lire la suivante',
    scanStampedPhotoDay: 'Tampon daté du jour de la photographie',
    scanCameraDenied: 'La caméra demeure close — confiez plutôt à Médard une photographie de votre appareil.',
    scanCameraBlocked: 'La caméra est bloquée — autorisez-la dans les réglages de votre navigateur (sur iPhone : « aA » dans la barre d’adresse → Réglages du site → Caméra → Autoriser), puis rechargez. Ou confiez à Médard une photographie de votre appareil.',
    scanTooBig: 'Cette photographie est trop volumineuse — essayez une prise plus légère.',
    scanBadImage: 'Ce format d\'image échappe à l\'œil de Médard — une photographie classique conviendra parfaitement.',
    scanSlowDown: 'Un instant, je vous prie — l\'œil de Médard reprend son souffle.',
    scanUnavailable: 'L\'œil de Médard se repose un instant. Veuillez réessayer dans un moment.',
    // « La magie de Médard » — réalité augmentée par monument
    arSectionTitle: 'Réalité augmentée',
    arOpen: 'Vivre l\'expérience',
    arSoon: 'Bientôt — la magie de Médard s\'y prépare',
    arArtistic: 'Évocation artistique — image générée par IA, non un artefact authentique',
    // Loi n°2 — le pendant de `arArtistic` : quand le maillage n'est PAS
    // inféré, il a été relevé par quelqu'un, et cette personne se nomme.
    // Les deux lignes ne sont jamais concurrentes (voir provenanceFor).
    arProvenance: 'Relevé réel — {source}',
    // La pastille d'astreinte du directeur, dans l'en-tête desktop /
    // kiosque — à quarante pixels du sélecteur de langue. Elle était en
    // français en dur ; {when} et l'horaire sont désormais formatés par
    // Intl depuis les champs structurés de l'API (Loi n°3).
    vincentBadgeReachable: 'Vincent · joignable',
    vincentBadgeBackAt: 'Vincent · de retour {when}',
    vincentBadgeBackSoon: 'bientôt',
    vincentBadgeSchedule: 'Du {first} au {last}, {from}–{to} (heure de Paris)',
    arAugusteTitle: 'Auguste — évocation en 3D',
    arTempleJanusTitle: 'Temple de Janus — Démonstration 3D',
    arMedardApparitionTitle: "L'Apparition de Médard — Démonstration",
    // Vitrine AR de l'Explorer (audit W6) — rendue UNIQUEMENT depuis arCatalog (Loi 1)
    arShowcaseTitle: 'La magie de Médard',
    // Compté depuis arCatalog au rendu (jamais écrit en dur) : la vitrine
    // annonce ce qui existe, « à ce jour » — et ne promet pas le reste.
    arShowcaseSubtitleOne: "Un monument, à ce jour, s'anime en réalité augmentée là où vous vous tenez.",
    arShowcaseSubtitleOther: "{n} monuments, à ce jour, s'animent en réalité augmentée là où vous vous tenez.",
    // La vérité avant le tap, à l'échelle de la carte (la phrase complète
    // reste `arArtistic`, dans la fiche).
    // NB — espace INSÉCABLE U+00A0 avant « IA » (idem en/es) : sur une
    // carte w-64 la légende passe à la ligne, et l'acronyme ne doit pas y
    // rester seul en bout de course.
    arShowcaseArtistic: 'Évocation artistique — forme générée par IA',
    arShowcaseCta: 'Vivre l\'expérience',
    // Teaser honnête de La Clef fermant la vitrine AR — ne nomme QUE ce qui
    // existe réellement derrière La Clef aujourd'hui (Loi 1).
    arClefTeaserTitle: 'La collection privée du Manoir',
    arClefTeaserLine: 'Les Merveilles de Médard, le Planificateur et les Services — réservés aux hôtes, avec La Clef.',
    arClefTeaserCta: 'Découvrir La Clef',
    arUnsupported: 'La réalité augmentée échappe encore à cet appareil — le Livre, lui, garde toute l\'histoire.',
    arClose: 'Fermer l\'expérience',
    // « Sur place » — la fenêtre magique (caméra + reconstruction)
    arModeStudio: 'Studio',
    arModeOnsite: 'Sur place',
    arOnsiteHint: 'Déplacez lentement votre téléphone — la reconstruction suit votre regard.',
    // Le même bandeau quand le capteur d'orientation manque ou a été refusé :
    // la consigne doit nommer la commande dont l'invité dispose vraiment.
    arOnsiteHintTouch: "Faites glisser un doigt pour tourner autour — ici, les mouvements du téléphone ne pilotent pas la vue.",
    arReplay: 'Revoir l\'éveil',
    arViewInRoom: 'Poser dans votre pièce',
    // « Réveillez Médard » — le pilote AR-carte (/reveil)
    reveilEyebrow: 'La magie de Médard',
    reveilTitle: 'Réveillez Médard',
    reveilIntro: "Pointez votre caméra vers la carte officielle de Médard : le hibou de porcelaine s'éveille et sort de la carte pour vous saluer.",
    reveilCardHint: "Imprimez la carte, ou affichez-la sur un autre écran.",
    reveilStart: 'Activer la caméra',
    reveilHint: 'Pointez la carte de Médard',
    reveilGreeting: "Vous m'avez réveillé… Bienvenue au Manoir d'Autun.",
    reveilUnsupported: "Cette expérience demande une caméra. Ouvrez cette page sur votre téléphone pour réveiller Médard.",
    reveilError: "La caméra n'a pas pu démarrer. Vérifiez l'autorisation, puis réessayez.",
    reveilPreparing: 'Médard rassemble sa magie… un instant.',
    reveilBack: 'Retour',
    updateAvailable: 'Une nouvelle version est disponible',
    updateReload: 'Actualiser',
    arModelSlow: 'Le modèle 3D est lourd et votre connexion semble lente.', arRetry: 'Réessayer',
    // « Médard souvenir » — capturer la scène puis la partager / l'enregistrer
    arPhoto: 'Photo souvenir',
    arShare: 'Partager',
    arSave: 'Enregistrer',
    arPhotoHint: 'Emportez Médard avec vous.',
    // « Rencontrez Médard en 3D » — l'affordance sur l'Audience privée
    arMeetMedard: 'Rencontrez Médard en 3D',
    arMeetMedardTitle: 'Médard — en trois dimensions',
    // « Autun en 3D » — La Carte du Temps (couche présent, Google 3D)
    autun3dTitle: 'Autun en 3D',
    autun3dEyebrow: 'La Carte du Temps',
    autun3dEraLabel: "Choisir l'époque",
    autun3dEraPresent: "Aujourd'hui",
    autun3dEraPast: 'Antiquité',
    autun3dEnceinteCredit: "Tracé d'après le plan de l'enceinte — DRAC/SRA Bourgogne, Archéologie en Bourgogne n°11 (Société Éduenne). Indicatif (~30 m). Trame (cardo, demi-decumani, îlots) d'après Rebourg, Gallia 1998 · Labaune & Kasprzyk, Gallia 2014 — indicative.",
    autun3dGateApprox: 'emplacement approximatif',
    // Ce panneau n'apparaît QUE sur un échec technique du client (hôte DOM
    // introuvable, ou le constructeur Leaflet qui lève). Rien n'est « en
    // préparation » et aucune date n'existe nulle part dans le dépôt : la
    // formule d'attente donnait à l'invité un rendez-vous que personne ne
    // pouvait honorer, et le renvoyait attendre au lieu de l'aider tout de
    // suite. Constat, puis un geste utile (Loi n°1).
    autun3dUnavailable: "La carte ne s'affiche pas",
    autun3dUnavailableHint: "Le survol 3D n'a pas pu se charger sur cet appareil. Réessayez en rechargeant la page ou depuis un autre réseau — ou demandez-moi de vous guider autrement.",
    autun3dDiscover: 'Découvrir',
    autun3dManoirLabel: "Le Manoir d'Autun",
    autun3dTourStart: 'Survol guidé',
    autun3dTourStep: 'Étape {n} / {total}',
    autun3dTourPause: 'Pause',
    autun3dTourResume: 'Reprendre',
    autun3dTourStop: 'Terminer',
    autun3dTourNarrationLabel: 'Narration de Médard',
    autun3dTourNarrationOn: '🔊 Médard raconte',
    autun3dTourNarrationOff: '🔇 Muet',
    autun3dGroundView: 'Vue au sol',
    autun3dGroundViewNone: 'Pas de vue au sol ici',
    autun3dEngineLabel: 'Vue de la carte',
    autun3dEngine2d: '2D',
    autun3dEngine3d: '3D',
    autun3dListen: 'Écouter',
    autun3dTourExpand: 'Agrandir',
    autun3dTourCollapse: 'Réduire',
    // « La Bibliothèque de Médard » — the guest library for the owner's
    // children's-book collection + the digital reader. Chrome only; the book
    // content (titles, tie-ins, planches, « Le Vrai ») stays FR in the payload.
    biblioMenuRow: 'La Bibliothèque de Médard',
    biblioReadNow: 'À lire maintenant',
    biblioReadCta: 'Lire le conte',
    biblioRead: 'Lire',
    biblioSoon: 'À paraître',
    biblioReserve: 'Réserver mon exemplaire',
    biblioReservePrefill: 'Bonjour, je souhaite être prévenu·e de la parution de « {title} » (Les Contes de Médard).',
    // « La Descente » — the scroll-scrubbed dive mounted over the library
    // door, once per session (phone). Chrome only, like the rest of biblio*.
    biblioDescenteRegion: "La Descente — l'entrée immersive de la Bibliothèque",
    biblioDescentePasser: 'Passer',
    biblioDescenteGlisser: 'Glissez pour descendre dans la Bibliothèque',
    biblioObjectLabel: 'L\'objet',
    biblioPhase2Eyebrow: 'Et bientôt',
    biblioPhase2Soon: 'Bientôt',
    biblioProgressReadable: 'à lire',
    biblioProgressComing: 'à paraître',
    biblioListen: 'Écouter le conte',
    biblioListenStop: 'Mettre en pause la lecture',
    biblioReaderPrev: 'Page précédente',
    biblioReaderNext: 'Page suivante',
    biblioReaderAr: 'Réalité augmentée',
    biblioLeVrai: 'Le Vrai du Conte',
    biblioLeVraiShort: 'Le Vrai',
    biblioError: 'La bibliothèque est momentanément indisponible — revenez dans un instant.',
    // « La Lanterne de Médard » — l'activation du code de coffret, au pied de
    // la Bibliothèque. La maison reconnaît la Lanterne, rien d'autre ne
    // change — jamais un mot d'argent, jamais une promesse d'accès (Loi 1).
    lanternePrompt: 'J\'ai une Lanterne',
    lanterneIntro: 'Votre Lanterne de Médard vous accompagne — confiez-moi son code, et la maison la reconnaîtra.',
    lanterneCodeLabel: 'Le code de votre Lanterne',
    lanterneCodeHint: 'Le code se trouve dans votre coffret.',
    lanterneSubmit: 'Allumer ma Lanterne',
    lanterneChecking: 'Vérification…',
    lanterneWrong: 'Cette lanterne ne s\'allume pas — vérifiez le code de votre coffret.',
    lanterneUnavailable: 'Nous ne pouvons pas vérifier votre Lanterne pour l\'instant — réessayez dans un moment.',
    myLanterneTitle: 'Ma Lanterne',
    myLanterneLifetime: 'Allumée — à vie',
    myLanterneUntil: 'Allumée — jusqu\'au {date}',
    myLanterneOff: 'Éteindre',
    intro: {
        chapeau: 'Le Manoir d\'Autun — Installation Médard',
        line1: 'Médard est sculpté en porcelaine de Delft, ceint d\'une chaîne d\'or au blason LM.',
        line2: 'À sa droite, le Livre Digital s\'illumine pour montrer ce que sa voix vous décrit.',
        line3: 'Toutes ses réponses citent des sources vérifiées par le Service Archéologique de la Ville d\'Autun.',
    },

    // — Guest-facing UI chrome that used to live as fr/en-only ternaries inside
    // components (Tourism-Office kiosk, galleries, the « verified » badge, the
    // silence toast). Centralised here so every offered language is covered and
    // the i18n.parity gate guards them. Proper nouns (Augustodunum, Wikimedia
    // Commons, « L'Horloge à la Lune ») are preserved across languages (Loi 2).
    guardianStatus: 'Médard, gardien du Manoir',
    kioskAgendaFooter: "Aujourd'hui à Autun · Office de Tourisme",
    kioskLegendsFooter: 'Légendes du Manoir',
    kioskAgendaHeadline: "Aujourd'hui à Autun",
    kioskAgendaSub: "Sélection de l'Office de Tourisme — scannez pour interroger Médard",
    kioskScanMore: 'Scannez — Médard vous en dira plus',
    kioskIdleWatch: 'Médard veille…',
    bookEmptyPrompt: '« Hou-hou… Que désirez-vous apprendre de la cité d\'Augustodunum ? »',
    monumentsTitle: "Les monuments d'Autun et de ses alentours",
    monumentsHere: 'À Autun',
    monumentsAround: 'Aux alentours',
    wikimediaGalleryTitle: 'Galerie · Wikimedia Commons',
    verifiedBadge: 'Vérifié',
    medardSilentError: 'Médard est momentanément silencieux. Réessayez dans un instant.',
    // Sa VOIX est indisponible — la réponse, elle, est arrivée et s'affiche.
    // Médard le dit lui-même plutôt que d'emprunter la voix synthétique du
    // téléphone en gardant son nom (voir pages/MedardExperience.jsx,
    // « Médard se tait plutôt que d'emprunter la voix d'un autre »). Aucun
    // diagnostic technique ici : le nom du fournisseur, le code d'erreur et
    // le mot « synthèse » ne regardent pas l'invité.
    medardVoiceLost: 'Médard a momentanément perdu la voix. Son récit reste ici, mot pour mot — il vous le dira dès qu\'il l\'aura retrouvée.',
    horlogeBookAlt: 'Médard et l\'Horloge à la Lune',
    contesFallbackTitle: 'Les Contes de Médard',

    // ── Le site desktop (07/09/2026, memory/strategie/SITE_WEB_DESKTOP.md) ──
    siteNavAutun: 'Autun',
    siteNavTresors: 'Trésors',
    siteNavFigures: 'Figures',
    siteNavManoir: 'Le Manoir',
    siteNavBibliotheque: 'Bibliothèque',
    siteNavMedard: 'Demandez à Médard',
    siteBrandGuardian: 'Médard, gardien de la mémoire',
    siteLangLabel: 'Langue',
    siteSkip: 'Aller au contenu',
    siteHeroEyebrow: 'Le Manoir d\'Autun présente',
    siteHeroMotto: 'Le monde est plus magique qu\'on ne le croit — parce qu\'il est vrai.',
    siteHeroLede: 'La mémoire d\'Autun — ses monuments, ses trésors, ses figures — racontée par Médard et sourcée par ceux qui creusent encore.',
    siteHeroCta: 'Explorer Autun',
    siteMerveillesEyebrow: "Ce qu'Autun garde",
    siteMerveillesTitle: 'Les merveilles d\'Autun',
    siteSeeAll: 'Tout voir',
    siteFriseEyebrow: 'La frise des époques',
    siteFriseTitle: 'Les couches de temps, et chaque trace à sa place',
    // La page de Médard (vague 3g) — les lois de la maison, publiées.
    siteMedardTitre: "Le gardien, et les règles auxquelles il est tenu",
    siteMedardLoisTitre: 'Les trois lois de Médard',
    siteMedardLoisLede: "Ce ne sont pas des promesses de brochure : ce sont les règles écrites dans le code qui le gouverne, et il ne peut pas y déroger.",
    siteMedardLoi1Titre: '100 % vrai',
    siteMedardLoi1: "Aucune affirmation historique sans source vérifiée. S'il ne sait pas, il le dit — « voilà une trace que je n'ai pas encore lue » — et il passe la main à l'équipe humaine. Jamais d'invention.",
    siteMedardLoi2Titre: 'Créditer',
    siteMedardLoi2: "Les découvertes appartiennent à ceux qui creusent. Médard nomme les chercheurs et les services — le SAVA, l'INRAP, Bibracte — et l'année où l'on a su.",
    siteMedardLoi3Titre: 'Servir avec chaleur',
    siteMedardLoi3: "Le ton du merveilleux, la précision du savant. Jamais mièvre, jamais robotique — et jamais un démenti à plat : votre vieux livre avait raison à son étage.",
    siteMedardJamaisTitre: "Ce que Médard ne fait jamais",
    siteMedardJamaisConseils: 'Aucun conseil médical, juridique ou financier.',
    siteMedardJamaisArgent: "Aucune réservation qui engage de l'argent sans confirmation humaine.",
    siteMedardJamaisDonnees: "Aucune donnée personnelle d'un autre client.",
    siteMedardJamaisImprovise: "Aucune improvisation historique — ni sur une date, ni sur une adresse.",
    siteMedardJamaisDenigre: 'Aucun dénigrement d\'un autre hôtel ou d\'une autre table.',
    siteMedardPourquoiTelephone: "Lui parler, l'écouter, lui montrer une façade : tout cela demande une caméra et une voix. Ce sont celles de votre téléphone, pas celles d'un écran d'ordinateur — nous préférons vous y conduire plutôt que d'en faire semblant ici.",
    // Le Manoir sur le SITE (vague 3f)
    siteManoirEyebrow: 'La maison',
    siteManoirInspiree: 'Inspirée par {name}',
    siteSuitePhotoAlt: '{name}, au Manoir d\'Autun',
    siteSuiteDetailAlt: '{name} — détail, au Manoir d\'Autun',
    siteFilmsEyebrow: 'Ce qui bouge',
    siteFilmsTitle: 'Les films',
    siteFilmsLede: 'Six clips filmés à Autun et au Manoir — chacun tient sa fiche et se regarde ici.',
    siteFilmsPlay: 'Lire le film : {name}',
    siteFilmsSeal: 'Film',
    siteFilmsFiche: 'Voir la fiche',
    // La page d'attente — le Manoir n'a pas encore ouvert (Steven, 15/09/2026).
    // ⚠ AUCUNE DATE : « bientôt » ne se dément pas, un mois annoncé se dément.
    bientotTitle: 'Bientôt',
    bientotVille: "Sous Autun dort Augustodunum. Deux portes romaines veillent encore aux entrées de la ville, un théâtre creuse toujours sa courbe dans la pente, et la cathédrale garde un nom gravé au XIIᵉ siècle dont nul n'a jamais su le maître.",
    bientotMaison: "Le Manoir en a fait huit suites. Chacune porte le nom d'un monument ou d'une figure d'Autun — l'empereur qui donna son nom à la ville, l'écolier Bonaparte, la cathédrale, le théâtre, l'horloge de la Lune. On n'y dort pas dans un décor : on y dort dans une histoire.",
    bientotMedard: "Et au comptoir veille un hibou. Médard connaît Autun comme on connaît une maison ; il répond à voix haute, à toute heure, et ne raconte que ce qu'il peut prouver — ce qu'il ignore, il le dit. Bientôt, il vous ouvrira.",
    bientotAccesErreur: "Ce lien n'ouvre pas encore la porte.",
    bientotAccesPanne: 'La porte ne répond pas — réessayez dans un instant.',
    bientotCourrielLabel: 'Écrire',
    siteSuiteAnecdotes: 'Ce que raconte la chambre',
    siteSuiteExperiences: 'Les expériences de la suite',
    siteSuiteExperiencesNote: 'Elles se vivent dans la suite, avec un téléphone ou un casque.',
    siteSuiteAr: 'Réalité augmentée',
    siteSuiteVr: 'Réalité virtuelle',
    // La Bibliothèque sur le SITE (vague 3e)
    siteContePlanche: 'Planche {n}',
    siteConteArPhone: 'En réalité augmentée sur votre téléphone',
    siteContePagesOne: '{n} planche',
    siteContePagesOther: '{n} planches',
    // Le carrefour du canon (vague 3d)
    siteAutunNav: 'Autun',
    siteAutunEyebrow: 'La mémoire de la ville',
    siteAutunTitle: "Cinq portes sur deux mille ans d'Autun",
    siteAutunLede: "Les pierres qu'on visite, les pièces qu'on admire, les gens qui les ont faites, les rendez-vous qui les font vivre — et le temps qui range le tout.",
    siteAutunCountOne: '{n} fiche',
    siteAutunCountOther: '{n} fiches',
    siteAutunEras: '{n} époques',
    siteAutunFriseLede: "Chaque trace à sa place dans le temps — et les époques côte à côte, familles mêlées.",
    // Les balades sur le SITE (vague 3c) — l'étagère et une balade ouverte.
    siteBaladesTitle: 'Huit chemins dans Autun, composés par la maison',
    siteBaladeStopOne: '{n} étape',
    siteBaladeStopOther: '{n} étapes',
    siteBaladeAsCrow: "{d} d'un point à l'autre, à vol d'oiseau",
    siteFichesCount: '{n} traces',
    siteCardOfDay: 'La carte du jour',
    siteMedardRaconte: 'Médard raconte',
    siteStay: 'Séjourner',
    siteStayOn: 'Sur le site du Manoir',
    siteGardienEyebrow: 'Le gardien du Manoir',
    siteAskTitle: 'Demandez à Médard',
    siteAskLede: 'Hibou-sentinelle d\'Augustodunum, je veille sur l\'histoire de la cité. Posez-moi votre question — et si je n\'ai pas encore lu la trace, je vous le dirai.',
    siteQrTitle: 'Emportez Médard avec vous',
    siteQrLede: 'La carte, l\'Œil et les balades vivent sur votre téléphone : scannez, et Médard vous suit.',
    siteFooterAutun: 'Autun',
    siteFooterMaison: 'La maison',
    siteFooterGardiens: 'Les gardiens',
    siteFooterGardiensText: 'Les découvertes appartiennent aux chercheurs : Service archéologique de la Ville d\'Autun, Inrap, Bibracte, musée Rolin. Chaque fiche cite ses sources.',
    siteFooterLivre: 'Le Livre de Médard · édition du lobby',
    siteFooterQuote: '« Moi, je ne fais que raconter. Les vrais gardiens, ce sont ceux qui creusent encore. »',
    siteWalkFromManoir: '{d} à pied du Manoir',
    siteWalkMinutes: '{d} · {min} min à pied',
    siteFromManoir: 'Depuis le Manoir',
    siteAddress: 'Adresse',
    siteOnMap: 'Sur la carte',
    siteItinerary: 'Itinéraire depuis le Manoir',
    siteReperes: 'Repères',
    siteAllReperes: 'Les {n} repères',
    siteFewerReperes: 'Replier les repères',
    siteSourcesEyebrow: 'Les sources de cette fiche',
    siteSourcesTitle: 'Les sources, et qui a trouvé quoi',
    siteSameLayer: 'Même couche de temps',
    siteCatalogueEyebrow: 'Autun',
    siteLegalEyebrow: 'La maison',
    siteLegalTitle: 'Mentions légales',
    siteLegalEditeur: 'Éditeur du site',
    siteLegalHebergeur: 'Hébergeur du site',
    siteLegalDirecteur: 'Directeur de la publication',
    siteLegalNomCommercial: 'Exploitant « {n} »',
    siteLegalAttendu: 'À compléter — cette information n\'a pas encore été reçue.',
    siteLegalManquantTitre: 'Mentions encore attendues',
    siteLegalProprieteTitre: 'Propriété intellectuelle',
    siteLegalPropriete: 'Les textes de ce site sont écrits par la maison. Chaque photographie porte son crédit sous l\'image ; celles qui n\'en portent pas encore le disent. Aucune reproduction sans accord écrit.',
    siteLegalSourcesTitre: 'Les gardiens',
    siteLegalSources: 'Les découvertes appartiennent aux chercheurs. Le Service archéologique de la Ville d\'Autun, l\'Inrap, Bibracte et le musée Rolin sont nommés dans chaque fiche qui leur doit quelque chose.',
    siteCatalogueLede: 'Chaque lieu, avec ses sources et sa distance à pied depuis le Manoir.',
    siteMore: 'Voir la suite',
    siteMoreRemaining: 'il reste {n} fiches',
    // ⚑ refonte 11/09 — le compte restant NOMME la famille (« il reste encore
    // 92 trésors ») ; `{compte}` porte le couple singulier/pluriel déjà traduit.
    siteMoreRemainingOf: 'il reste encore {compte}',
    siteFilterAll: 'Tous',
    siteFilterPatrimoine: 'Patrimoine',
    siteFilterNature: 'Nature',
    siteMonumentsCount: '{n} monuments',
    siteTresorsCount: '{n} trésors',
    siteFiguresCount: '{n} figures',
    siteFetesCount: '{n} rendez-vous',
    siteReperesFrench: 'Ces repères sont en français.',
    sitePhotoPending: 'Photographie à venir',
    siteNotFoundTitle: 'Voilà une trace que je n\'ai pas encore lue',
    siteNotFoundLede: 'Cette page n\'existe pas — ou pas encore. Revenez à l\'accueil : la mémoire d\'Autun y est tout entière.',
    siteBackHome: 'Retour à l\'accueil',
    siteFailed: 'Le canon ne répond pas pour le moment. Réessayez dans un instant.',
    siteRetry: 'Réessayer',
    siteCrumbMonuments: 'Monuments',
    siteKnowledgeAsOf: 'Savoir arrêté à {year}',
    siteNotTranslated: 'Ce récit est en français.',
    baladeBestMode: 'Comment la faire',
    baladeFrenchNote: 'Cette note pratique est en français.',
    siteOnPhone: 'Sur votre téléphone',
    // audit 10/09 — routage & robustesse
    siteWideOnlyTitle: 'Cette page se lit sur grand écran',
    siteWideOnlyLede: 'Les contes, la Bibliothèque et les suites du Manoir se lisent sur un ordinateur ou une tablette. L\'adresse reste la bonne : gardez-la, et retrouvez Médard sur votre téléphone à l\'accueil.',
    siteWideOnlyHome: 'Ouvrir Médard sur ce téléphone',
    // audit 10/09 — parcours
    siteIdentitySuites: 'Découvrir les huit suites',
    siteTelephoneLabel: 'Téléphone',
    siteRebondLieu: 'Au même endroit',
    siteRebondFamille: 'À découvrir aussi',
    siteVoisinsTitle: 'À quelques pas',
    siteEtapeBaladeEyebrow: 'Étape d\'une balade',
    siteEtapeBaladeRang: 'étape {n} sur {total}',
    siteMedardPortesTitre: 'Et maintenant',
    siteMedardPortesLede: 'Trois portes pour le voir à l\'œuvre.',
    siteMedardPorteFiche: 'Lire une fiche, avec ses sources',
    siteMedardPorteBiblio: 'Ouvrir la Bibliothèque',
    siteMedardPorteBalades: 'Suivre une balade',
    // audit 10/09 — vérité & sept langues
    siteDriveFromManoir: '{d} du Manoir, en voiture',
    siteDriveDistance: '{d} · en voiture',
    // « celui de son voisin, X » : un nom de lieu porte souvent son article
    // (« celui de Temple de Janus » était faux) — cette forme tient pour tous.
    sitePointEmprunte: 'Point approximatif — celui de son voisin, {name}',
    sitePointApproximatif: 'Point approximatif',
    siteLieuNonNomme: 'Nos sources ne nomment pas le lieu.',
    siteFrenchForNow: 'En français pour l\'instant.',
    suiteFloorPremier: 'Premier étage',
    suiteFloorDeuxieme: 'Deuxième étage',
    siteLegalManqueDonnees: 'Données personnelles — la notice d\'information reste à rédiger.',
    siteLegalManqueCookies: 'Cookies et stockage local — la notice reste à rédiger.',
    // audit 10/09 — a11y-design
    siteCrumbsLabel: "Fil d'Ariane",
    explorerMapTouchToExplore: 'Toucher pour explorer la carte',
    siteLegalDtDenomination: 'Dénomination',
    siteLegalDtAdresse: 'Siège',
    siteLegalDtSiret: 'SIRET · APE',
    siteLegalDtRcs: 'Immatriculation',
    siteLegalDtTva: 'TVA intracommunautaire',
    siteLegalDtCapital: 'Capital social',
    siteLegalDtTelephone: 'Téléphone',
    // audit 10/09 bis — carte-et-titres
    siteCarteNav: 'La carte',
    siteCarteTitle: 'La carte d\'Autun',
    siteCarteLede: 'Chaque monument du canon à sa place, le Manoir marqué d\'or — et, depuis lui, la distance à pied ou en voiture.',
    siteCarteCountOne: '{n} lieu sur la carte',
    siteCarteCountOther: '{n} lieux sur la carte',
    siteCarteVoir: 'Voir sur la carte',
    siteCarteSansEpingleTitle: 'Sans épingle propre',
    siteCarteSansEpingleLede: 'Le point de ces lieux est celui d\'un voisin : la fiche le dit, la carte ne l\'invente pas.',
    siteVoisinsCarte: 'Toute la carte d\'Autun',
    // audit 10/09 bis — verite-2
    wikimediaLightboxSource: 'Source · Wikimedia Commons',
    wikimediaLightboxPage: 'Page Wikimedia',
    sitePinVoisin: 'L\'épingle est celle de son voisin, {name} — cette fiche n\'a pas de point à elle.',
    // refonte 11/09 — la porte nomme sa famille, elle ne compte plus des « fiches »
    siteAutunCountMonumentsOne: '{n} monument',
    siteAutunCountMonumentsOther: '{n} monuments',
    siteAutunCountTresorsOne: '{n} trésor',
    siteAutunCountTresorsOther: '{n} trésors',
    siteAutunCountFiguresOne: '{n} figure',
    siteAutunCountFiguresOther: '{n} figures',
    siteAutunCountFetesOne: '{n} rendez-vous',
    siteAutunCountFetesOther: '{n} rendez-vous',
    // « La cité antique en 3D » — le visualiseur web du modèle Blender
    // d'Augustodunum (components/mobile/CiteAntique3D.jsx). La grammaire
    // ①②③ reprend mot pour mot les définitions du script qui bâtit le modèle
    // (tools/schola/augustodunum_ville.py, « LES TROIS COLLECTIONS »).
    citeTitle: 'La cité antique en 3D',
    citeEyebrow: 'Augustodunum, la ville romaine',
    citeStatement: "Une carte en trois dimensions de ce qu'on sait — pas une ville reconstituée.",
    citeViewLabel: 'Vue en trois dimensions de la cité antique — glissez pour tourner, pincez pour zoomer',
    citeLoading: 'Chargement de la cité…',
    citeLoadingPercent: 'Chargement de la cité — {p} %',
    citeNoWebglTitle: "La 3D ne s'affiche pas sur cet appareil",
    citeNoWebglBody: "Votre navigateur ne fournit pas WebGL, dont la cité en 3D a besoin. La carte « Autun en 3D » sait s'en passer : l'enceinte antique y est tracée.",
    citeErrorTitle: "La cité ne s'est pas chargée",
    citeErrorBody: "Le modèle ou ses crédits n'ont pas pu être lus. Vérifiez la connexion, puis réessayez.",
    citeRetry: 'Réessayer',
    citeOpenMap: 'Ouvrir la carte « Autun en 3D »',
    citeCertGroup: 'Degrés de certitude',
    citeCertA: '① Attesté',
    citeCertR: '② Restitué',
    citeCertH: '③ Hypothèse',
    citeCertADesc: 'coordonnées et cotes portées par le canon, sourcées',
    citeCertRDesc: "déduit d'une donnée attestée",
    citeCertHDesc: 'ajouté par nous — chaque objet porte son motif',
    citeIllustrationToggle: 'Montrer un tissu urbain générique (illustration, non restitué)',
    citeIllustrationBadge: 'Illustration — non restitué',
    citeIllustrationDesc: 'posé pour que la ville se lise comme une ville ; ni attesté ni restitué, hors décompte',
    citeMode: 'Voir la certitude',
    citeLegendTitle: 'Légende',
    citeSeenTitle: 'Ce que vous voyez',
    citeSeenLine: '{a} % attesté · {r} % restitué · {h} % hypothèse',
    citeSeenCountOne: "sur {n} objet dans le champ — un compte d'objets, pas un volume",
    citeSeenCountOther: "sur {n} objets dans le champ — un compte d'objets, pas un volume",
    citeSeenIllustrationOne: '+ {n} illustration, hors décompte',
    citeSeenIllustrationOther: '+ {n} illustrations, hors décompte',
    citeSeenRepereOne: '+ {n} repère de lieu, hors décompte',
    citeSeenRepereOther: '+ {n} repères de lieu, hors décompte',
    citeRepereBadge: 'Repère de lieu',
    citeRepereNote: 'Le lieu est connu ; la forme dessinée n\'est qu\'un repère — aucune source ne donne son emprise.',
    citeSeenNone: 'Aucun objet dans le champ',
    citeHint: 'Touchez un objet pour lire ce qui le fonde.',
    citeReset: "Revenir à la vue d'ensemble",
    citeMonumentsOpen: 'Les monuments',
    citeMonumentsTitle: 'Les monuments du modèle',
    citeMonumentsIntro: "Choisissez un monument : la vue s'y porte et sa description s'ouvre.",
    citeMissingTitle: 'Ce qui manque',
    citeMissingIntro: 'Le modèle montre ses trous autant que ses murs. Voici ce que les sources ne donnent pas, tel que le modèle le déclare.',
    citeSourceTextFr: 'texte source, en français',
    citeCreditsOpen: 'Crédits',
    citeCreditsTitle: 'Crédits et licences',
    citeCreditsIntro: "Les cotes viennent des fiches du canon, qui citent le service archéologique de la Ville d'Autun (SAVA), l'Inrap et les chercheurs qu'elles nomment. Les mentions ci-dessous sont reproduites telles que leurs sources les exigent.",
    citeCreditsSource: 'Source',
    citeCreditsLicence: 'Licence',
    citeCreditsObligation: 'Ce que la licence demande',
    citeCardNom: 'Nom dans le modèle',
    citeCardNote: 'Note de source',
    citeCardHeight: 'Hauteur non sourcée — motif',
    citeCardBreakdown: 'Ce monument dans le modèle : {a} ① · {r} ② · {h} ③ (en objets)',
    citeCardDistance: "{d} du Manoir, à vol d'oiseau",
    citeCardOpenFiche: 'Ouvrir la fiche',
    citeCardNoFiche: "Cet objet n'a pas de fiche dans le canon.",
    // La cité antique en 3D sur le SITE (10/10/2026, pages/site/SiteCiteAntique.jsx) :
    // le même visualiseur, posé dans une page d'ordinateur. Le téléphone dit
    // « glissez, pincez » et renvoie à « Autun en 3D », que le site n'a pas ;
    // sur le site la souris clique, la molette ne zoome qu'une fois la vue
    // choisie (elle ne vole pas le défilement de la page), et le repli sans
    // WebGL est la carte d'Autun.
    citeViewLabelSite: 'Vue en trois dimensions de la cité antique — faites glisser pour tourner, cliquez puis utilisez la molette pour zoomer',
    citeHintSite: "Cliquez sur un objet pour lire ce qui le fonde. Pour zoomer à la molette, cliquez d'abord dans la vue.",
    citeNoWebglBodySite: "Votre navigateur ne fournit pas WebGL, dont la cité en 3D a besoin. La carte d'Autun, en deux dimensions, s'en passe.",
    citeOpenMapSite: "Ouvrir la carte d'Autun",
    siteCiteGrammaire: "Chaque objet du modèle porte son degré de certitude, et vous choisissez lesquels voir. Une hypothèse est toujours dessinée translucide et cernée d'un trait : elle ne passe jamais pour de la pierre.",
    siteCiteAussi: 'La cité, autrement',
    // La porte « Voir dans la cité en 3D » (10/10/2026) — sur la fiche d'un
    // monument que le modèle pose (lib/citeFiches) : la vue s'y porte et sa
    // description s'ouvre. Fiche du site et fiche du téléphone.
    citeVoirDans: 'Voir dans la cité en 3D',
};

export default FR;
